/**
 * BURN COMPUTE: Pure functions for energy expenditure calculations (BMR, METs, Training).
 */

export const BurnCompute = {
    getWalkingMET(kmh: number): number {
        if (kmh < 3) return 2.0;
        if (kmh < 4.5) return 3.0;
        if (kmh < 5.5) return 3.5;
        if (kmh < 6.5) return 4.3;
        return 5.0; 
    },

    calculateCardioBaseline(
        weightKg: number, 
        durationMins: number, 
        distanceKm: number = 0, 
        intensityPercent: number = 50
    ): number {
        let baseMET = 3.0;
        if (distanceKm > 0 && durationMins > 0) {
            const speed = (distanceKm / durationMins) * 60;
            baseMET = this.getWalkingMET(speed);
        }
        const intensityFactor = intensityPercent / 50; 
        const adjustedMET = baseMET * intensityFactor;
        const activeMET = Math.max(0.5, adjustedMET - 1);
        return Math.round((activeMET * 3.5 * weightKg / 200) * durationMins);
    },

    calculateStrengthBaseline(
        tonnageKg: number, 
        weightKg: number, 
        durationMins: number, 
        avgRpe: number = 7
    ): number {
        const mechanicalBurn = tonnageKg * 0.12;
        const rpeFactor = avgRpe / 7; 
        const basalMET = 2.0; 
        const activityBurn = (basalMET * 3.5 * weightKg / 200) * durationMins;
        return Math.round((mechanicalBurn + activityBurn) * rpeFactor);
    },

    calculateBMR(gender: string, heightCm: number, weightKg: number, birthDate: string, bodyFatPercentage?: number | null): number {
        // Phase 2 Biological Sink Upgrade: Use Cunningham if Body Fat % is known
        if (bodyFatPercentage && bodyFatPercentage > 0 && bodyFatPercentage < 60) {
            const leanBodyMass = weightKg * (1 - (bodyFatPercentage / 100));
            // Cunningham Equation (Gold standard for athletic populations)
            const bmr = 500 + (22 * leanBodyMass);
            return Math.round(bmr);
        }

        // Fallback: Mifflin-St Jeor
        const age = birthDate ? (new Date().getFullYear() - new Date(birthDate).getFullYear()) : 30;
        let bmr = (10 * weightKg) + (6.25 * heightCm) - (5 * age);
        if (gender === 'MALE') bmr += 5;
        else bmr -= 161;
        return Math.round(bmr);
    }
};
